module.exports = __webpack_public_path__ + "static/img/casino-title.593a020.jpg";